module.exports = __webpack_public_path__ + "static/media/Detailer.52cd98a3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Products/Detailer.pdf
// module id = 330
// module chunks = 0